const isListingProductPrice = (price) => {
  return "originalPrice" in price;
};
const getPriceSpecificationConfig = (pricing, vat) => {
  const originalPrice = isListingProductPrice(pricing) ? pricing.originalPrice : pricing.value.centAmount;
  const discountedPrice = isListingProductPrice(pricing) ? pricing.discount?.price ?? 0 : pricing.discounted?.value.centAmount ?? 0;
  const currency = isListingProductPrice(pricing) ? pricing.currencyCode : pricing.value.currencyCode;
  const validFrom = isListingProductPrice(pricing) ? pricing.discount?.validFrom : pricing.discounted?.discount?.obj?.validFrom;
  const validThrough = isListingProductPrice(pricing) ? pricing.discount?.validUntil : pricing.discounted?.discount?.obj?.validUntil;
  const price = discountedPrice > 0 ? discountedPrice : originalPrice;
  const vatRate = vat ? vat : 0;
  return {
    price,
    vatRate,
    currency,
    validFrom,
    validThrough
  };
};
export {
  getPriceSpecificationConfig
};
//# sourceMappingURL=get-price-specification-config.js.map
